import { PriorityRule, PriorityRules } from './priority-rules.model';

PriorityRulesController.$inject = ['$scope', '$translate', '$mdDialog', 'company', 'sites', 'PriorityRulesFactory', 'AlertingFactory', 'ConfirmationFactory', 'TopToolbarFactory'];
export function PriorityRulesController($scope, $translate, $mdDialog, company, sites, PriorityRulesFactory, AlertingFactory, ConfirmationFactory, TopToolbarFactory) {

  $scope.editRule = editRule;
  $scope.deleteRule = deleteRule;
  $scope.addRule = addRule;
  $scope.save = save;
  $scope.enableSave = enableSave;

  init();

  function editRule(index, event) {
    enableSave();
    $mdDialog.show({
      'controller': 'PriorityRuleEditionController',
      'template': require('./priority-rule-edition.dialog.html'),
      'targetEvent': event,
      'clickOutsideToClose': false,
      'locals': {
        'dropdownItems': $scope.dropdownItems,
        'rule': angular.copy($scope.rules[index])
      }
    })
      .then(function (modifiedRule) {
        $scope.config.updateRule(index, modifiedRule);
      });
  }

  function deleteRule(index) {
    ConfirmationFactory.materialConfirmDialog('priority-rules/confirm-deletion')
      .then(function () {
        enableSave();
        $scope.config.deleteRule(index);
      });

  }

  function addRule(event) {
    enableSave();
    $scope.config.addRule(new PriorityRule($translate.instant('priority-rules/edition/default-rule-title')));
    editRule($scope.rules.length - 1, event);
  }

  function save() {
    PriorityRulesFactory.updatePriorityRules(company.id, $scope.config)
      .then(() => {
        AlertingFactory.success('priority-rules/update-success');
        disableSave();
      },
        AlertingFactory.httpErrorHandler()
      );
  }

  function enableSave() {
    TopToolbarFactory.updateButtonDisable(false, $scope);
  }

  function disableSave() {
    TopToolbarFactory.updateButtonDisable(true, $scope);
  }

  function init() {

    TopToolbarFactory.setTitleTranslation('priority-rules/title', $scope);
    TopToolbarFactory.setButton('save', save, $scope);
    TopToolbarFactory.setSecondaryButton('priority-rules/create', addRule, $scope);

    disableSave();

    PriorityRulesFactory.getPriorityRules(company.id)
      .then(response => {
        const isNewConfig = Object.keys(response.data).length === 0; // Initial value is '{}' in the SQL table
        $scope.config = isNewConfig ? new PriorityRules() : PriorityRules.fromBackEnd(response.data);
        $scope.rules = $scope.config.rules;
      },
        AlertingFactory.httpErrorHandler()
      );
    $scope.dropdownItems = PriorityRulesFactory.buildDropdownItems(sites, company.tags_groups);
    $scope.globalSorts = PriorityRules.globalSortItems();
    $scope.rulesSortOptions = {
      'axis': 'y',
      'cursor': 'move',
      'handle': '.drag-handle',
      'change': () => enableSave()
    }
  }

}
